module.exports = __webpack_public_path__ + "static/17-16fad1e4552872bf07b3eefa978f8bd9.mp4";